module.exports = __webpack_public_path__ + "c59bf385659260e16ff9f74d34784b73.svg";